module.exports = __webpack_public_path__ + "img/logo_diginamic.e5b2ec76.svg";